import { IModeloTecnico } from "@/hooks/modelos/buscar-modelo-unico-por-cliente/interface";

interface IVisualizacaoModeloTecnicoProps {
  modelo: IModeloTecnico;
}

export function VisualizacaoModeloTecnico({ modelo }: IVisualizacaoModeloTecnicoProps) {
  return (
    <div className="mx-auto w-full space-y-10 p-6">
      {/* Imagens - Frente e Verso */}
      <div className="grid grid-cols-1 gap-10 md:grid-cols-2">
        {/* Frente */}
        <div className="flex flex-col items-center rounded-lg bg-white p-4 shadow">
          <h2 className="mb-2 text-lg font-semibold text-gray-700">Foto da Frente</h2>
          <img
            src={
              modelo?.foto_frente_url ??
              "https://static.expanssiva.com.br/uploads/imagens/modelos/cracha_em_tons_de_azul.png"
            }
            alt="Foto Frente"
            className="max-h-80 rounded-lg object-contain shadow-md"
          />
        </div>

        {/* Verso */}
        <div className="flex flex-col items-center rounded-lg bg-white p-4 shadow">
          <h2 className="mb-2 text-lg font-semibold text-gray-700">Foto do Verso</h2>
          <img
            src={
              modelo?.foto_verso_url ??
              "https://static.expanssiva.com.br/uploads/imagens/modelos/cracha_em_tons_de_azul.png"
            }
            alt="Foto Verso"
            className="max-h-80 rounded-lg object-contain shadow-md"
          />
        </div>
      </div>

      {/* Tabela técnica */}
      <div className="overflow-x-auto rounded-lg bg-white shadow-md">
        <h2 className="border-b py-4 text-center text-xl font-bold text-gray-800">
          Descrição da Ficha Técnica
        </h2>

        <table className="min-w-full border-separate border-spacing-y-1 text-sm text-gray-700">
          <thead className="bg-bg-table-row text-gray-800">
            <tr>
              <th className="border-b px-6 py-3 text-left font-semibold">Campo Chave</th>
              <th className="border-b px-6 py-3 text-left font-semibold">Nome dos Campos</th>
            </tr>
          </thead>
          <tbody>
            {modelo?.campos_variaveis?.length > 0 ? (
              modelo.campos_variaveis.map((campo, idx: number) => (
                <tr key={idx} className="transition hover:bg-green-200">
                  <td className="border-t px-6 py-2">
                    {idx === 0 ? (modelo?.campo_chave ?? "N/A") : ""}
                  </td>
                  <td className="border-t px-6 py-2">{campo?.nome ?? "N/A"}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td className="px-6 py-3 text-center text-gray-500" colSpan={2}>
                  Nenhum campo encontrado.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Informações adicionais */}
      <div className="space-y-3 rounded-lg bg-white p-6 text-gray-700 shadow-md">
        <h3 className="mb-2 text-lg font-semibold text-gray-800">Informações Complementares</h3>

        <p>
          <span className="font-medium">Tecnologia:</span>{" "}
          {modelo?.tecnologia?.nome ?? "Nenhuma Tecnologia"}
        </p>
        <p>
          <span className="font-medium">Orientação:</span> {modelo?.posicionamento}
        </p>
        <p>
          <span className="font-medium">Furo:</span> {modelo?.tem_furo ? "Tem furo" : "Sem furo"}
        </p>
        <p>
          <span className="font-medium">Tipo de entrega:</span> {modelo?.tipo_entrega}
        </p>
        <p className="text-red-500">
          <span className="font-medium">Observação:</span>{" "}
          {modelo?.observacoes || "Nenhuma observação"}
        </p>
      </div>
    </div>
  );
}
